"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sdTheme = void 0;
var greys_1 = require("./greys");
var PRIMARY = "#ff4c7a";
var SECONDARY = "#00e19e";
var SINEDESIGN = ["#FFAC81", "#DEEFB7", "#98DFAF", "#5FB49C", "#82668F"];
exports.sdTheme = {
    typography: {
        fontFamily: [
            "Raleway",
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"'
        ].join(",")
    },
    palette: {
        type: "dark",
        primary: {
            main: PRIMARY,
        },
        secondary: {
            main: SECONDARY
        },
        background: {
            default: greys_1.grey["100"],
            paper: greys_1.grey["500"]
        },
        grey: greys_1.grey,
        sinedesign: SINEDESIGN
    },
    shape: {
        borderRadius: 8
    },
    transitions: {
        duration: {
            shortest: 25,
            shorter: 50,
            short: 100,
            // most basic recommended timing
            standard: 150,
            // this is to be used in complex animations
            complex: 150,
            // recommended when something is entering screen
            enteringScreen: 225,
            // recommended when something is leaving screen
            leavingScreen: 195
        }
    },
    props: {
        MuiButtonBase: {
            disableTouchRipple: true
        },
        MuiButton: {
            variant: "contained",
            disableElevation: true
        },
        MuiCard: {
            elevation: 0
        },
        MuiFormControl: {
            size: "small"
        },
        MuiTabs: {
            TabIndicatorProps: {
                style: {
                    display: "none"
                }
            }
        },
        MuiTextField: {
            size: "small"
        }
    },
    overrides: {
        MuiButton: {
            root: {
                textTransform: "none",
                minWidth: "100px",
                borderRadius: "25px"
            }
        }
    }
};
